"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUPLES = void 0;
exports.COUPLES = [
    // Application passager — consultée au soleil, debout, quelques secondes.
    {
        surface: 'passager',
        role: 'Texte principal',
        couleur: '#0D1F1C',
        fond: '#FFFFFF',
        ratioAnnonce: 17.07,
    },
    {
        surface: 'passager',
        role: 'Texte secondaire',
        couleur: '#5A706A',
        fond: '#FFFFFF',
        ratioAnnonce: 5.3,
    },
    {
        surface: 'passager',
        role: 'Texte tertiaire',
        couleur: '#5C706C',
        fond: '#FFFFFF',
        ratioAnnonce: 5.26,
    },
    {
        surface: 'passager',
        role: 'Texte tertiaire sur surface douce',
        couleur: '#5C706C',
        fond: '#E4F1EE',
        ratioAnnonce: 4.54,
    },
    {
        surface: 'passager',
        role: 'Accent sur fond',
        couleur: '#046A63',
        fond: '#FFFFFF',
        ratioAnnonce: 6.47,
    },
    {
        surface: 'passager',
        role: 'Libellé sur bouton plein',
        couleur: '#FFFFFF',
        fond: '#046A63',
        ratioAnnonce: 6.47,
    },
    {
        surface: 'passager',
        role: 'Accent sombre sur accent doux',
        couleur: '#03514C',
        fond: '#E4F1EE',
        ratioAnnonce: 7.93,
    },
    { surface: 'passager', role: 'Alerte', couleur: '#A62B1F', fond: '#F7DEDA', ratioAnnonce: 5.5 },
    {
        surface: 'passager',
        role: 'Attention',
        couleur: '#8F5400',
        fond: '#F7E9CE',
        ratioAnnonce: 5.09,
    },
    // Application chauffeur — tableau de bord, souvent de nuit, longues sessions.
    {
        surface: 'chauffeur',
        role: 'Texte principal',
        couleur: '#E9F2EE',
        fond: '#0B1A17',
        ratioAnnonce: 15.67,
    },
    {
        surface: 'chauffeur',
        role: 'Texte secondaire',
        couleur: '#A2B8B2',
        fond: '#0B1A17',
        ratioAnnonce: 8.55,
    },
    {
        surface: 'chauffeur',
        role: 'Texte tertiaire',
        couleur: '#829994',
        fond: '#13251F',
        ratioAnnonce: 5.28,
    },
    {
        surface: 'chauffeur',
        role: 'Texte tertiaire sur surface haute',
        couleur: '#829994',
        fond: '#1B322B',
        ratioAnnonce: 4.51,
    },
    {
        surface: 'chauffeur',
        role: 'Accent sur fond',
        couleur: '#3FBFAE',
        fond: '#0B1A17',
        ratioAnnonce: 7.9,
    },
    {
        surface: 'chauffeur',
        role: 'Libellé sur bouton plein',
        couleur: '#04211D',
        fond: '#3FBFAE',
        ratioAnnonce: 7.48,
    },
    {
        surface: 'chauffeur',
        role: 'Accent sombre sur accent doux',
        couleur: '#7FDACB',
        fond: '#102F2A',
        ratioAnnonce: 8.75,
    },
    { surface: 'chauffeur', role: 'Alerte', couleur: '#E8796B', fond: '#38201C', ratioAnnonce: 5.3 },
    {
        surface: 'chauffeur',
        role: 'Attention',
        couleur: '#E0A43C',
        fond: '#33280F',
        ratioAnnonce: 6.58,
    },
    // Console — poste de travail, tableaux à balayer, base 15 px.
    {
        surface: 'console',
        role: 'Texte principal',
        couleur: '#101F1C',
        fond: '#FFFFFF',
        ratioAnnonce: 17.01,
    },
    {
        surface: 'console',
        role: 'Texte secondaire',
        couleur: '#465C57',
        fond: '#FFFFFF',
        ratioAnnonce: 7.17,
    },
    {
        surface: 'console',
        role: 'Texte tertiaire',
        couleur: '#5F726E',
        fond: '#FFFFFF',
        ratioAnnonce: 5.1,
    },
    {
        surface: 'console',
        role: 'Texte tertiaire sur panneau',
        couleur: '#5F726E',
        fond: '#F6F9F8',
        ratioAnnonce: 4.81,
    },
    {
        surface: 'console',
        role: 'Pastille conforme',
        couleur: '#046A63',
        fond: '#DCEEEA',
        ratioAnnonce: 5.38,
    },
    {
        surface: 'console',
        role: 'Accent sombre sur accent doux',
        couleur: '#03514C',
        fond: '#DCEEEA',
        ratioAnnonce: 7.64,
    },
    {
        surface: 'console',
        role: 'Texte tertiaire sur fond',
        couleur: '#5F726E',
        fond: '#EFF3F1',
        ratioAnnonce: 4.56,
    },
    {
        surface: 'console',
        role: 'Pastille attention',
        couleur: '#8F5400',
        fond: '#F8EAD0',
        ratioAnnonce: 5.14,
    },
    {
        surface: 'console',
        role: 'Pastille critique',
        couleur: '#A62B1F',
        fond: '#F7DFDB',
        ratioAnnonce: 5.54,
    },
];
//# sourceMappingURL=couples.js.map